import script from "./VTableHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableHeader.vue?vue&type=script&setup=true&lang=js"

import "./VTableHeader.vue?vue&type=style&index=0&id=45687344&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45687344"]])

export default __exports__